<div class="d-sm-flex align-items-center justify-content-between mb-4">
  <h1 class="h2 mb-0">Tranzactii & facturi</h1>
  <ul class="nav nav-tabs nav-justified flex-nowrap mb-0 pt-3 pt-sm-0" role="tablist">
    <li class="nav-item" role="presentation">
      <button (click)="onTabSelected(tabs.INCOMING)" [ngClass]="{'active' : selectedTab === tabs.INCOMING}"
        class="nav-link" type="button" role="tab">
        <i class="ai-card me-2"></i>Incasari</button>
    </li>
    <li class="nav-item" role="presentation">
      <button (click)="onTabSelected(tabs.OUTGOING)" [ngClass]="{'active' : selectedTab === tabs.OUTGOING}"
        class="nav-link" type="button" role="tab">
        <i class="ai-send me-2"></i>Plati</button>
    </li>
  </ul>
</div>
<div class="card border-0 py-1 p-md-2 p-xl-3 p-xxl-4">
  <div class="card-body pb-4">
    <!-- Transaction list-->
    <div class="tab-content">

      <!-- Incoming transactions -->
      <div [ngClass]="{'show active': selectedTab === tabs.INCOMING}" class="tab-pane fade" role="tabpanel">
        <div class="d-sm-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
          <div class="d-flex align-items-center">
            <i class="ai-card text-primary lead pe-1 me-2"></i>
            <h2 class="h4 mb-0">Incasari</h2>
          </div>
          <div class="ms-auto d-flex pt-3 pt-sm-0">
            <div *ngIf="pdfScriptsLoaded" ngbDropdown class="dropdown ms-auto me-2">
              <button ngbDropdownToggle type="button" class="btn btn-secondary btn-sm dropdown-toggle">
                <i class="ai-download me-2 ms-n1"></i>Exporta
              </button>
              <ul ngbDropdownMenu class="dropdown-menu my-1">
                <li><a ngbDropdownItem (click)="exportAsPdf()" class="dropdown-item" role="button">PDF</a></li>
                <li><a ngbDropdownItem (click)="exportAsExcel()" class="dropdown-item" role="button">Excel</a></li>
              </ul>
            </div>
            <select [(ngModel)]="filterIncoming" (ngModelChange)="onFilterIncomingChange()"
              class="form-select form-select-sm">
              <option value="all">Toate tranzactiile</option>
              <option value="last-week">Ultima saptamana</option>
              <option value="last-month">Ultima luna</option>
              <option value="pending">In asteptare</option>
              <option value="refunded">Rambursate</option>
              <option value="finalized">Finalizate</option>
            </select>
          </div>
        </div>
        <ng-container *ngIf="incoming">
          <div
            *ngFor="let transaction of filteredIncoming | slice: (pageIncoming - 1) * itemsPerPageIncoming : pageIncoming * itemsPerPageIncoming; first as first"
            class="row gx-0 fs-4 fw-normal py-3 border-bottom" [ngClass]="{'border-top': first}">
            <div class="col-8 col-sm-4">
              <div class="fs-sm text-muted"><i class="ai-time me-2 ms-n1"></i>{{transaction.createdDate | date:
                'MMM d, y, HH:mm':undefined:'ro'}}</div>
              <span
                [ngClass]="{'bg-faded-warning text-warning': transaction.walletStatus === 'Pending', 'bg-faded-success text-success': transaction.walletStatus === 'Finalized', 'bg-faded-danger text-danger': transaction.walletStatus === 'Refunded'}"
                class="badge fs-xs">{{getTransactionStatusText(transaction)}}</span>
            </div>
            <div class="col-8 col-sm-5 order-3 order-sm-2 pt-3 pt-sm-0">
              <div class="fs-sm text-muted mb-2">{{transaction.userName}}</div>
              <div class="fs-sm fw-medium text-dark" [innerHTML]="getTransactionDescription(transaction) | safe:'html'">
              </div>
            </div>
            <div class="col-4 col-sm-1 order-4 order-sm-3 pt-3 pt-sm-0">
              <ng-container *ngIf="transaction.invoiceCode">
                <div class="fs-sm text-muted mb-2">Factura</div>
                <div class="fs-sm fw-medium text-dark"><a *ngIf="transaction.invoiceCode" (click)="onDownloadInvoice(transaction.invoiceCode)" role="button"><i class="ai-file-text text-primary lead pe-1 me-2"></i></a></div>
              </ng-container>
            </div>
            <div class="col-4 col-sm-2 order-2 order-sm-4 text-sm-end">
              <div class="fs-sm text-muted mb-2">Valoare</div>
              <div class="fs-sm fw-medium text-dark">{{transaction.amount | number:'1.2-2'}} lei</div>
            </div>
          </div>

          <!-- Pagination-->
          <div *ngIf="incoming?.length" class="d-sm-flex align-items-center pt-4 pt-sm-5">
            <nav class="order-sm-2 ms-sm-auto mb-4 mb-sm-0" aria-label="Orders pagination">
              <ngb-pagination [(page)]="pageIncoming" [collectionSize]="filteredIncoming.length"
                [pageSize]="itemsPerPageIncoming" [maxSize]="5" [directionLinks]="false" [boundaryLinks]="false" [rotate]="true"
                size="sm" (pageChange)="onPageIncomingChanged($event)"
                class="d-flex justify-content-center"></ngb-pagination>
            </nav>
          </div>
        </ng-container>

        <!-- No items -->
        <div *ngIf="incoming?.length === 0" class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Nu ai primit nicio contributie la evenimentele tale.</p>
            <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-primary w-100 w-sm-auto mb-2 mb-sm-0">Cum
              functioneaza</a>
            <a [routerLink]="['/user/creare-eveniment']" class="btn btn-primary w-100  w-sm-auto ms-sm-2">Creeaza
              eveniment</a>
          </div>
        </div>

        <!-- No filter results template -->
        <div *ngIf="incoming?.length > 0 && filteredIncoming?.length === 0"
          class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
          </div>
        </div>

        <!-- Loading template -->
        <div *ngIf="!incoming">
          <div *ngFor="let item of [].constructor(10); last as last" [ngClass]="{'border-bottom': last}"
            class="border-top placeholder-glow py-2" aria-hidden="true">
            <span class="placeholder placeholder-lg col-3 me-2"></span>
            <span class="placeholder placeholder-lg col-4 me-2"></span>
            <span class="placeholder placeholder-lg col-3"></span>
            <span class="placeholder col-2 me-2"></span>
            <span class="placeholder col-9"></span>
          </div>
        </div>
      </div>

      <!-- Outgoing transactions -->
      <div [ngClass]="{'show active': selectedTab === tabs.OUTGOING}" class="tab-pane fade" role="tabpanel">
        <div class="d-sm-flex align-items-center pb-4 mt-sm-n1 mb-0 mb-lg-1 mb-xl-3">
          <div class="d-flex align-items-center">
            <i class="ai-send text-primary lead pe-1 me-2"></i>
            <h2 class="h4 mb-0">Plati</h2>
          </div>
          <div class="ms-auto d-flex pt-3 pt-sm-0">
            <div *ngIf="pdfScriptsLoaded" ngbDropdown class="dropdown ms-auto me-2">
              <button ngbDropdownToggle type="button" class="btn btn-secondary btn-sm dropdown-toggle">
                <i class="ai-download me-2 ms-n1"></i>Exporta
              </button>
              <ul ngbDropdownMenu class="dropdown-menu my-1">
                <li><a ngbDropdownItem (click)="exportAsPdf()" class="dropdown-item" role="button">PDF</a></li>
                <li><a ngbDropdownItem (click)="exportAsExcel()" class="dropdown-item" role="button">Excel</a></li>
              </ul>
            </div>
            <select [(ngModel)]="filterOutgoing" (ngModelChange)="onFilterOutgoingChange()"
              class="form-select form-select-sm ms-auto">
              <option value="all">Toate tranzactiile</option>
              <option value="last-week">Ultima saptamana</option>
              <option value="last-month">Ultima luna</option>
              <option value="pending">In asteptare</option>
              <option value="refunded">Rambursate</option>
              <option value="finalized">Finalizate</option>
            </select>
          </div>
        </div>
        <ng-container *ngIf="outgoing">
          <div
            *ngFor="let transaction of filteredOutgoing | slice: (pageOutgoing - 1) * itemsPerPageOutgoing : pageOutgoing * itemsPerPageOutgoing; first as first"
            class="row gx-0 fs-4 fw-normal py-3 border-bottom" [ngClass]="{'border-top': first}">
            <div class="col-8 col-sm-4">
              <div class="fs-sm text-muted"><i class="ai-time me-2 ms-n1"></i>{{transaction.createdDate | date:
                'MMM d, y, HH:mm':undefined:'ro'}}</div>
              <span
                [ngClass]="{'bg-faded-warning text-warning': transaction.walletStatus === 'Pending', 'bg-faded-success text-success': transaction.walletStatus === 'Finalized', 'bg-faded-danger text-danger': transaction.walletStatus === 'Refunded'}"
                class="badge fs-xs">{{getTransactionStatusText(transaction)}}</span>
            </div>
            <div class="col-8 col-sm-5 order-3 order-sm-2 pt-3 pt-sm-0">
              <div class="fs-sm text-muted mb-2">{{transaction.userName}}</div>
              <div class="fs-sm fw-medium text-dark" [innerHTML]="getTransactionDescription(transaction) | safe:'html'">
              </div>
            </div>
            <div class="col-4 col-sm-1 order-4 order-sm-3 pt-3 pt-sm-0">
              <ng-container *ngIf="transaction.invoiceCode">
                <div class="fs-sm text-muted mb-2">Factura</div>
                <div class="fs-sm fw-medium text-dark"><a (click)="onDownloadInvoice(transaction.invoiceCode)" role="button"><i class="ai-file-text text-primary lead pe-1 me-2"></i></a></div>
              </ng-container>
           </div>
            <div class="col-4 col-sm-2 order-2 order-sm-4 text-sm-end">
              <div class="fs-sm text-muted mb-2">Valoare</div>
              <div class="fs-sm fw-medium text-dark">{{transaction.amount | number:'1.2-2'}} lei</div>
            </div>
          </div>

          <!-- Pagination-->
          <div *ngIf="filteredOutgoing?.length" class="d-sm-flex align-items-center pt-4 pt-sm-5">
            <nav class="order-sm-2 ms-sm-auto mb-4 mb-sm-0" aria-label="Orders pagination">
              <ngb-pagination [(page)]="pageOutgoing" [collectionSize]="filteredOutgoing.length"
                [pageSize]="itemsPerPageOutgoing" [maxSize]="5" [directionLinks]="false" [boundaryLinks]="false" [rotate]="true"
                size="sm" (pageChange)="onPageOutgoingChanged($event)"
                class="d-flex justify-content-center"></ngb-pagination>
            </nav>
          </div>
        </ng-container>


        <!-- No items -->
        <div *ngIf="outgoing?.length === 0" class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-data.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Nu ai nicio tranzactie la campaniile tale.</p>
            <a [routerLink]="['/corporate/creare-campanie']" class="btn btn-primary w-100 w-sm-auto">Creeaza campanie</a>
          </div>
        </div>

        <!-- No filter results template -->
        <div *ngIf="outgoing?.length > 0 && filteredOutgoing?.length === 0"
          class="card border-0 bg-secondary text-center">
          <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
          <div class="card-body">
            <h4 class="card-title">Nicio inregistrare</h4>
            <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
          </div>
        </div>

        <!-- Loading template -->
        <div *ngIf="!outgoing">
          <div *ngFor="let item of [].constructor(5); last as last" [ngClass]="{'border-bottom': last}"
            class="border-top placeholder-glow py-2" aria-hidden="true">
            <span class="placeholder placeholder-lg col-3 me-2"></span>
            <span class="placeholder placeholder-lg col-4 me-2"></span>
            <span class="placeholder placeholder-lg col-3"></span>
            <span class="placeholder col-2 me-2"></span>
            <span class="placeholder col-9"></span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
